import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';
import AccordionListModule from 'bundles/degree-description/components/modules/program-details/AccordionListModule';

export type AdmissionRequirementsItem = {
  id: string;
  question: string;
  answer: string;
};

export type AdmissionRequirementsSection = {
  sectionTitle: string;
  items: AdmissionRequirementsItem[];
};

export type AdmissionRequirementsModuleProps = {
  heading: string;
  description: string;
  sections: AdmissionRequirementsSection[];
};

const AdmissionRequirementsModule = ({ heading, description, sections }: AdmissionRequirementsModuleProps) => (
  <AccordionListModule
    heading={heading}
    description={description}
    sections={sections.map((section) => ({
      sectionTitle: section.sectionTitle,
      items: section.items.map((item) => ({
        id: item.id,
        label: item.question,
        content: <Markdown source={item.answer} trackingName="admission_requirements_link" />,
      })),
    }))}
  />
);

export default AdmissionRequirementsModule;
